import React from "react";

//css
import "./IrStyles.css";

const IrHeader = () => {
  return (
    <section className="irheader-main" id="investor-relations">
      <div className="main-padding">
        <div className="main-margin">
          <h1 className="text-white ml-[-10px] md:ml-0 text-4xl md:text-[42px] font-semibold">Investor Relations</h1>
        </div>
      </div>
    </section>
  );
};

export default IrHeader;
